(function () {
  'use strict';

  if (window.__cmHideQty) return;
  window.__cmHideQty = true;

  var CM_ITEM = 'form[data-instant-repeater-type="CART_ITEMS"]';
  var CM_PRICE = '[data-instant-dynamic-content-source="TOTAL_PRICE"]';
  var CM_CLASS = 'hidden-quantity';
  var cmTimer = null;

  // "$0" / "$0.00" -> true ; "$120,000" -> false
  function cmIsZero(text) {
    var digits = (text || '').replace(/\D/g, '');
    return digits !== '' && Number(digits) === 0;
  }

  function cmApply() {
    var items = document.querySelectorAll(CM_ITEM);
    for (var i = 0; i < items.length; i++) {
      var price = items[i].querySelector(CM_PRICE);
      items[i].classList.toggle(CM_CLASS, !!price && cmIsZero(price.textContent));
    }
  }

  function cmSchedule() {
    clearTimeout(cmTimer);
    cmTimer = setTimeout(cmApply, 60);
  }

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, cmSchedule);
  });

  // Instant reemplaza los nodos del drawer y también solo cambia el texto del precio
  if (window.MutationObserver) {
    new MutationObserver(cmSchedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  cmApply();
  window.cmHideQuantity = cmApply;
})();

(function () {
  'use strict';

  if (window.__cmReward) return;

  var CM_R = (window.__cmReward = {
    goal: 120000 * 100,
    selector: '.pdp-reward-box',
    klass: 'rewarded',
    pending: null,
    queued: false,
    timer: null
  });

  function cmApply(total) {
    var boxes = document.querySelectorAll(CM_R.selector);
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].classList.toggle(CM_R.klass, total >= CM_R.goal);
    }
  }

  function cmRefresh() {
    if (CM_R.pending) {
      CM_R.queued = true;
      return CM_R.pending;
    }
    CM_R.pending = fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cmApply(cart.total_price); })
      .catch(function () {})
      .finally(function () {
        CM_R.pending = null;
        if (CM_R.queued) {
          CM_R.queued = false;
          cmSchedule();
        }
      });
    return CM_R.pending;
  }

  function cmSchedule() {
    clearTimeout(CM_R.timer);
    CM_R.timer = setTimeout(cmRefresh, 150);
  }

  // Instant confirma el add de forma asíncrona: se consulta varias veces
  function cmBurst() {
    cmSchedule();
    setTimeout(cmRefresh, 700);
    setTimeout(cmRefresh, 1800);
  }

  var CM_CART_RE = /\/cart\/(add|change|update|clear)/i;

  var cmFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    return cmFetch.apply(this, arguments).then(function (res) {
      if (CM_CART_RE.test(url)) cmSchedule();
      return res;
    });
  };

  var cmOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cmRewardUrl = url;
    return cmOpen.apply(this, arguments);
  };
  var cmSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener('load', function () {
      if (CM_CART_RE.test(self._cmRewardUrl || '')) cmSchedule();
    });
    return cmSend.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, cmSchedule);
  });

  // Acciones de carrito en la página (add, +, -, eliminar)
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-instant-action-type], [name="add"], form[action*="/cart"], [data-cart-remove], [href*="/cart/change"]')) {
      cmBurst();
    }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) cmSchedule();
  });
  window.addEventListener('pageshow', cmRefresh);

  cmRefresh();
  CM_R.refresh = cmRefresh;
})();


(function () {
  'use strict';

  if (window.__cmCartTimer) return;

  var CM_T = (window.__cmCartTimer = {
    duration: 5 * 60 * 1000,
    label: 'Solo por tiempo limitado',
    selector: '.timer-text-cart',
    endsAt: null,
    interval: null
  });

  function cmPad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function cmNodes() {
    return document.querySelectorAll(CM_T.selector);
  }

  // Hay varios overlays en la página: el del carrito es el que
  // contiene el timer, no necesariamente el primero del DOM
  function cmCartIsOpen() {
    var overlays = document.querySelectorAll('[data-instant-type="overlay"][data-state]');
    for (var i = 0; i < overlays.length; i++) {
      if (overlays[i].querySelector(CM_T.selector)) {
        return overlays[i].dataset.state === 'open';
      }
    }
    return false;
  }

  function cmText() {
    var diff = CM_T.endsAt - Date.now();
    if (diff <= 0) return CM_T.label + '.';

    var total = Math.ceil(diff / 1000);
    return CM_T.label + ': ' + cmPad(Math.floor(total / 60)) + ':' + cmPad(total % 60);
  }

  function cmRender() {
    if (!CM_T.endsAt) return;

    var nodes = cmNodes();
    var text = cmText();
    for (var i = 0; i < nodes.length; i++) {
      // Solo se escribe si cambió: evita realimentar el MutationObserver
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }

    if (CM_T.endsAt - Date.now() <= 0 && CM_T.interval) {
      clearInterval(CM_T.interval);
      CM_T.interval = null;
    }
  }

  function cmStart() {
    if (CM_T.endsAt) return; // ya arrancó: no se reinicia al reabrir
    CM_T.endsAt = Date.now() + CM_T.duration;
    if (!CM_T.interval) CM_T.interval = setInterval(cmRender, 1000);
  }

  function cmCheck() {
    if (cmCartIsOpen()) cmStart();
    cmRender(); // Instant reemplaza el nodo al repintar: se vuelve a pintar
  }

  if (window.MutationObserver) {
    new MutationObserver(cmCheck).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state']
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) cmRender();
  });

  cmCheck();
  window.__cmCartTimer.check = cmCheck;
})();